import { Logo } from '@fast-radius/shared-ui';
import React from 'react';

import { MARKETING_URLS } from 'fr-shared/lib/marketing_urls';

import { Link } from 'portal/components';

import styles from './FooterInsights.module.css';

const FooterInsights = () => {
  return (
    <>
      <div className="container-sm my-5">
        <div className="bg-gray-600 rounded-md insights-relative">
          <div className="p-3">
            <h3 className="mb-3">Want to talk to someone about your project?</h3>
            <p>
              Need an expert? Our Manufacturing Success Team can help you design for
              manufacturability, select materials, evaluate post-processing choices, run cost
              analyzes, determine inspection criteria, and more.
            </p>
            <p>
              <Link to="/contact-us">Reach out to Our Team</Link> to get started.
            </p>
          </div>
        </div>
      </div>
      <div className={styles.Footer}>
        <div className="pt-4 pb-5">
          <div className="container-sm ">
            <div className="flex flex-col md:flex-row justify-content-between">
              <div>
                <Logo className="mb-2" fill="white" />
                <div>
                  <div className="mb-1">
                    <Link
                      className="text-decoration-none"
                      to={{ pathname: MARKETING_URLS.Resources }}
                      openNewWindow
                    >
                      Resources
                    </Link>
                  </div>
                  <div className="mb-1">
                    <Link
                      className="text-decoration-none"
                      to={{ pathname: MARKETING_URLS.Legal }}
                      openNewWindow
                    >
                      Legal Notices
                    </Link>
                  </div>
                  <div className="mb-1">
                    <Link
                      className="text-decoration-none"
                      to={{ pathname: MARKETING_URLS.Privacy }}
                      openNewWindow
                    >
                      Privacy Policy
                    </Link>
                  </div>
                  <div className="mb-1">
                    <Link
                      className="text-decoration-none"
                      to={{ pathname: MARKETING_URLS.TermsAndConditions }}
                      openNewWindow
                    >
                      Terms and Conditions
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterInsights;
